"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var Calendar_1 = __importDefault(require("material-ui/DatePicker/Calendar"));
var Clock_1 = __importDefault(require("material-ui/TimePicker/Clock"));
var Dialog_1 = __importDefault(require("material-ui/Dialog"));
var Button_1 = __importDefault(require("../Button"));
var utils_1 = require("../../../utils");
var lodash_1 = require("lodash");
var DatePickerDialog = /** @class */ (function (_super) {
    __extends(DatePickerDialog, _super);
    function DatePickerDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleTouchTapOk = function () {
            var _a = _this.props, dateOnly = _a.dateOnly, onChange = _a.onChange, handleDialog = _a.handleDialog, dispatch = _a.dispatch, dateTimeInISO = _a.dateTimeInISO, suffix = _a.suffix;
            if (!_this.calendar.isSelectedDateDisabled()) {
                var d = _this.calendar.getSelectedDate();
                var t = dateOnly
                    ? {
                        getHours: function () {
                            return 0;
                        },
                        getMinutes: function () {
                            return 0;
                        },
                    }
                    : _this.clock.getSelectedTime();
                handleDialog();
                var month = lodash_1.padStart(d.getMonth() + 1, 2, '0');
                var day = lodash_1.padStart(d.getDate(), 2, '0');
                var hours = lodash_1.padStart(t.getHours(), 2, '0');
                var minutes = lodash_1.padStart(t.getMinutes(), 2, '0');
                if (dateOnly) {
                    onChange(d.getFullYear() + "-" + month + "-" + day + suffix);
                    dispatch(utils_1.createAction('TEXT', day + "." + month + "." + d.getFullYear()));
                }
                else {
                    onChange(dateTimeInISO
                        ? new Date(d.getFullYear() + "-" + month + "-" + day + " " + hours + ":" + minutes + ":00.000").toISOString().substr(0, 16)
                        : d.getFullYear() + "-" + month + "-" + day + "T" + hours + ":" + minutes + suffix);
                    dispatch(utils_1.createAction('TEXT', day + "." + month + "." + d.getFullYear() + " " + hours + ":" + minutes));
                }
            }
        };
        _this.handleToday = function () {
            var _a = _this.props, commitOnToday = _a.commitOnToday, dateOnly = _a.dateOnly;
            var today = new Date();
            _this.calendar.setSelectedDate(today);
            if (!dateOnly && !commitOnToday) {
                _this.clock.handleChangeHours(today.getHours(), true);
                setTimeout(function () {
                    _this.clock.handleChangeMinutes(today.getMinutes(), true);
                    _this.clock.setMode('hour');
                });
            }
            if (commitOnToday) {
                _this.handleTouchTapOk();
            }
        };
        return _this;
    }
    DatePickerDialog.prototype.render = function () {
        var _this = this;
        var _a = this.props, minutesStep = _a.minutesStep, cancelLabel = _a.cancelLabel, disableYearSelection = _a.disableYearSelection, initialDate = _a.initialDate, locale = _a.locale, theme = _a.theme, maxDate = _a.maxDate, minDate = _a.minDate, mode = _a.mode, okLabel = _a.okLabel, shouldDisableDate = _a.shouldDisableDate, dateOnly = _a.dateOnly, todayLabel = _a.todayLabel, showToday = _a.showToday;
        var styles = {
            container: { display: 'flex', alignItems: 'flex-start' },
            header: __assign({ position: 'absolute', height: 10, width: '100%' }, theme.header),
            clock: { width: 280, marginTop: 6 },
            today: { color: 'black', display: 'flex', justifyContent: 'center' },
            today_a: { cursor: 'pointer' },
            dialogContent: { width: dateOnly ? 310 : 590 },
            dialogBodyContent: {
                padding: 0,
                minHeight: dateOnly ? 161 : 409,
                minWidth: dateOnly ? 310 : 310,
            },
        };
        var actions = [
            react_1.default.createElement(Button_1.default, { key: 0, label: okLabel, onClick: this.handleTouchTapOk, primary: true }),
            react_1.default.createElement(Button_1.default, { key: 1, label: cancelLabel, style: { marginLeft: 5 }, onClick: this.props.handleDialog }),
        ];
        return (react_1.default.createElement(Dialog_1.default, { actions: actions, bodyStyle: styles.dialogBodyContent, contentStyle: styles.dialogContent, ref: "dialog", repositionOnUpdate: true, open: true, onRequestClose: this.handleRequestClose, style: styles.dialogBodyContent },
            react_1.default.createElement("div", { style: styles.container },
                react_1.default.createElement("div", { style: styles.header }),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Calendar_1.default, { autoOk: false, DateTimeFormat: Intl.DateTimeFormat, disableYearSelection: disableYearSelection, firstDayOfWeek: 1, initialDate: initialDate, locale: locale, maxDate: maxDate, minDate: minDate, mode: mode, open: true, ref: function (node) {
                            _this.calendar = node;
                        }, onTouchTapCancel: this.handleTouchTapCancel, okLabel: false, shouldDisableDate: shouldDisableDate }),
                    showToday && (react_1.default.createElement("div", { style: styles.today },
                        react_1.default.createElement("a", { onClick: this.handleToday, style: styles.today_a }, todayLabel)))),
                !dateOnly && (react_1.default.createElement("div", { style: styles.clock },
                    react_1.default.createElement(Clock_1.default, { format: "24hr", minutesStep: minutesStep, initialTime: initialDate, ref: function (node) {
                            _this.clock = node;
                        } }))))));
    };
    return DatePickerDialog;
}(react_2.Component));
exports.default = DatePickerDialog;
//# sourceMappingURL=DateTimeDialog.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/DateTime/DateTimeDialog.js
// module id = 2058
// module chunks = 0